import { useLanguage } from '@infominds/react-native-components'
import React from 'react'
import { StyleSheet, Text, TouchableOpacity } from 'react-native'

import Colors from '../constants/Colors'
import { View } from './Themed'

interface Props {
  state: unknown
  isOthers: boolean
  hasComment: boolean
  onPress?: () => void
}

function StateBadge({ state, onPress, isOthers, hasComment }: Props) {
  const { i18n } = useLanguage()

  const StateText = () => {
    switch (state) {
      case 'OK':
        return i18n.t('ID_OK_1')
      case 'NOTOK':
        return i18n.t('ID_KO')
      case 'RETURNED':
        return i18n.t('ID_RETURN')
      case 'FORWARDED':
        return i18n.t('ID_FORWARDED')
      case 'UNREAD':
        return '' //TODO
      case 'READED':
        return '' //TODO
      case 'DELETED':
        return state //TODO
      case 'TASKDONE':
        return i18n.t('ID_TASKDONE')
      case 'PARTIALOK':
        return i18n.t('ID_PARTIALOK')
      case 'OPEN':
        return i18n.t('ID_OPEN')
      default:
        return ''
    }
  }

  if (StateText() !== '') {
    return (
      // eslint-disable-next-line react-native/no-inline-styles
      <View style={{ backgroundColor: 'transparent' }}>
        <TouchableOpacity onPress={onPress} style={[styles.badge, [state === 'NOTOK' ? styles.notOk : styles.ok]]} disabled={onPress === undefined}>
          <Text style={styles.text}>
            {isOthers && i18n.t('ID_OTHERS') + ': '}
            {StateText()}
          </Text>
        </TouchableOpacity>
        {hasComment ? (
          <View
            // eslint-disable-next-line react-native/no-inline-styles
            style={{
              backgroundColor: Colors.tintOpposite,
              position: 'absolute',
              top: -1,
              right: -1,
              height: 12,
              width: 12,
              borderRadius: 8,
            }}
          />
        ) : (
          <View />
        )}
      </View>
    )
  } else {
    return <View />
  }
}

const styles = StyleSheet.create({
  badge: {
    padding: 10,
    borderRadius: 20,
    opacity: 1,
  },
  ok: {
    backgroundColor: Colors.tint,
  },
  notOk: {
    backgroundColor: Colors.tintOpposite,
  },
  text: {
    color: '#fff',
  },
})

export default StateBadge
